import React from 'react';

const StarBackground = () => {
  const starCount = 60; // Adjust the number of stars as needed

  return (
    <div
      style={{
        width: '100%',
        height: '80vh',
        position: 'relative',
      }}
    >
      {[...Array(starCount)].map((_, index) => (
        <div
          key={index}
          className="fa-regular fa-star "
          style={{
            color: '#ffd43b',
            position: 'absolute',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            transform: 'translate(-50%, -50%)',
           // To center the stars
          }}
        />
      ))}
    </div>
  );
};

export default StarBackground;
